import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Press, Logo } from '@dorixona/ui'
import { profileView } from '../features/account/model'
import { useUnreadCount } from '../features/notifications/api'
import { Icon } from '../ui/Icon'
import { useSession } from './session'
import { useScrolled } from './useScrolled'
import { env } from '../config/env'

/**
 * Шапка приложения: логотип и вход либо колокольчик уведомлений и личный
 * кабинет. В покое прозрачная — экран начинается сразу с содержимого; при
 * прокрутке проявляется стеклом, иначе строки проезжали бы прямо под логотипом.
 */
export function MobHeader() {
  const { t } = useTranslation(['common', 'account', 'catalog'])
  const navigate = useNavigate()
  const { isAuthenticated, customer } = useSession()
  const scrolled = useScrolled()
  const profile = profileView(customer)
  const unread = useUnreadCount(isAuthenticated).data ?? 0

  return (
    <header className="mob-header" data-scrolled={scrolled}>
      <div className="mh-in">
        <div className="logo">
          <Logo className="logo-h" />
        </div>
        <div className="mh-right">
          {/* Значки стоят вплотную: у каждого своя цель 44pt, а лишний зазор
              между ними на узкой шапке читался как разрыв. */}
          <span className="mh-icons">
            {/* Избранное есть и у гостя — вход к нему в шапке, рядом с колокольчиком. */}
            {env.features.favorites ? (
              <Press
                squish="icon"
                className="hicon"
                aria-label={t('catalog:favorites.title')}
                onPress={() => {
                  void navigate('/favorites')
                }}
              >
                <Icon name="i-heart" />
              </Press>
            ) : null}
            {isAuthenticated ? (
              <Press
                squish="icon"
                className="hicon"
                aria-label={
                  unread
                    ? t('account:inbox.bellUnread', { count: unread })
                    : t('account:inbox.title')
                }
                onPress={() => {
                  void navigate('/notifications')
                }}
              >
                <Icon name="i-bell" />
                {unread ? (
                  <span className="hbadge num" aria-hidden="true">
                    {unread > 99 ? '99+' : unread}
                  </span>
                ) : null}
              </Press>
            ) : null}
          </span>
          {isAuthenticated ? (
            <Press
              squish="icon"
              className="mh-avatar"
              aria-label={
                profile.known
                  ? `${t('common:screens.profile')}: ${profile.fullName}`
                  : t('common:screens.profile')
              }
              onPress={() => {
                void navigate('/profile')
              }}
            >
              <span aria-hidden="true">{profile.initials}</span>
            </Press>
          ) : (
            <Button
              small
              onPress={() => {
                void navigate('/login')
              }}
            >
              {t('common:actions.signIn')}
            </Button>
          )}
        </div>
      </div>
    </header>
  )
}
